import React, { useState } from 'react';
import './detailed-activity-list-table.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck, faFilter, faLayerGroup, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Modal from '@/components/modal/modal.component';
import ActivityFilters from './activity-filters.component';
import { format } from 'date-fns';
import LayeredIcons from '../layered-icons/layered-icons.component';
import ImageContainer from '../image-container/image-container.component';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const DetailedActivityListTable = ({
  gameData,
  activityToDisplay,
  playerList,
  gameElements,
  manager,
  gameManagers,
  goToTransaction,
  hidePlayer
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const navigate = useNavigate();

  return (
    <div className={`detailed-activity-list-table ${screenSize}`}>
      <table className='g-table'>
        <thead>
          <tr>
            <th></th>
            <th>Date</th>
            {
              (!location.pathname.includes('/play/')) &&
              <th className='player'>Player</th>
            }
            <th>Activity</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            (
              Object.keys(activityToDisplay).length > 0 && 
              playerList &&
              gameElements
            )
              ?
              Object.values(activityToDisplay)
                .sort((a, b) => a.ts < b.ts ? 1 : -1)
                .map(a => {
                  const playerData = playerList[a.playerId];
                  console.log(a);
                  // console.log(playerData);
                  if (a.playerId && !playerData) return null;
                  return (
                  <tr key={a.id} id={a.id}>
                    <td 
                    width={screenSize === 'mobile' ? '30px' : '40px'} 
                    style={{ padding: '.25rem' }}>
                      <div className='activity-icon'>
                        {
                          (a.type === 'submittedItem')
                            ?
                            <div style={{ 'color': 'var(--item-color)' }}>
                              <FontAwesomeIcon icon={faLayerGroup} size='2x' />
                            </div>
                            :
                            (a.type === 'declinedItem')
                              ?
                              <LayeredIcons
                                icon1={faLayerGroup}
                                icon1Color='var(--item-color)'
                                icon1Size='2x'
                                icon2={faBan}
                                icon2Color='red'
                                icon2Size='2x'
                              />
                              :
                              (a.type === 'approvedItem')
                                ?
                                <LayeredIcons
                                  icon1={faLayerGroup}
                                  icon1Size='2x'
                                  icon1Color='var(--item-color)'
                                  icon2={faCheck}
                                  icon2Color='lightgreen'
                                  icon2Size='2x'
                                />
                                :
                              (a.icon)
                              ?
                              <ImageContainer src={a.icon} />
                              :
                              (a.elementId)
                              ?
                              <ImageContainer src={gameElements[a.elementId]?.icon} />
                              :
                              ''
                        }
                      </div>
                    </td>
                    <td>{format(new Date(a.ts), "Pp")}</td>
                    
                    {
                      (!location.pathname.includes('/play/')) &&
                      <td className='player'>
                        {
                          (playerData) 
                          ? playerData.fName + ' ' + playerData.lName 
                          : ''
                        }
                      </td>
                    }
                    <td>
                      {a.event}
                      {
                        (a.elementId && gameElements && gameElements[a.elementId]) && 
                        <span className='meta'><br />({gameElements[a.elementId].name})</span>
                      }
                    </td>
                    <td>
                      <div className='notes'>
                        {
                          (a.data && a.data.logs && a.data.logs.length > 0) &&
                          <div>{a.data.logs.length
                            // a.data.logs.reduce((total, r) => {
                            //   if (r.type === 'xp' || r.type === 'currency') {
                            //     return total + 1;
                            //   }
                            //   return total + r.quantity;
                            // }, 0)
                          } Total Rewards</div>
                        }
                        {
                          (a.comments && hidePlayer) &&
                          <div>Comments: "{a.comments}"</div>
                        }
                        {
                          (a.type === 'purchase') &&
                          <div>
                            <div className='item-cost'>Total Cost: <ImageContainer src='/images/icons/coin.png' className='coin-icon' /> {a.cartTotal}</div> <div>Total Items: {a.cartQuantity}</div>
                          </div>
                        }
                        {
                          (a.elementId && gameElements && gameElements[a.elementId] && a.quantity)
                          &&
                          <div>{a.quantity && <span>(x{a.quantity})</span>} </div>
                          
                        }
                      </div>
                    </td>
                    <td className='actions'>
                      {
                        (location.pathname.includes('/xp')) &&
                        <div className='amount'>
                          <ImageContainer src='/images/xp.png' className='icon' />
                          {
                            Object.values(a.data).find(r => r.type === 'xp').quantity
                            ?
                            Object.values(a.data).find(r => r.type === 'xp').quantity.toLocaleString()
                            :
                            'Unknown'
                          }
                        </div>
                      }
                      {
                        (location.pathname.includes('/currency')) &&
                        <div className='amount'>
                          <ImageContainer src='/images/icons/coin.png' className='icon' />
                          {
                            a.type === 'purchase'
                            ?
                            <span className='debit'>-{a.cartTotal.toLocaleString()}</span>
                            :
                            Object.values(a.data).find(r => r.type === 'currency')?.quantity
                            ?
                            Object.values(a.data).find(r => r.type === 'currency')?.quantity.toLocaleString()
                            :
                            'Unknown'
                          }
                        </div>
                      }
                      {
                        (manager || a.playerId === playerData.playerId)
                          ?
                          <div className='actions'>
                            {
                              (a.type === 'purchase' || a.type === 'rewards' || (a.data && Object.values(a.data).length > 0)) &&
                              <div className='buttons'>
                                <button
                                  className='g-button small-btn'
                                  onClick={() => goToTransaction(a.path)}>
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                              </div>
                            }
                          </div>
                          :
                          <div></div>
                      }
                    </td>
                  </tr>
                )})
              :
              <tr>
                <td colSpan="6">No activity records found.</td>
              </tr>
          }
        </tbody>
      </table>
    </div>
  )
}

export default DetailedActivityListTable